<div class="ace-heading-banner-title-lot">
<div class="row" style="margin-top:15px;">
    <div class="col-4">
        <div style="margin-top:15px;margin-left:12px;">
            <span class="ace-heading-text-level-1">{{_title}}</span>
        </div>
    </div>
    <div class="col-4">
        <div style="margin-top:15px;">
        <span class="ace-heading-text-level-1">
            Lot {{_lotNumber}} - {{_lotName}}</span>
        </div>
    </div>
</div>
</div>

